import React, { useEffect, useState } from 'react';
import {
  checkError,
  getObjFromLS,
  getOrganizationDate,
  restRequest,
} from '../../../Helpers';
import { Field, Form, FormAction } from '../../../Components/Form';
import { CustomModal, Loader } from '../../../Components';
import { withFormik } from 'formik';
import { t } from 'i18next';
import { FaBullhorn, FaExclamationTriangle } from 'react-icons/fa';

const handleFormSubmit = async (
  values,
  { setSubmitting, props: { handleToast, history, setIsLoading } }
) => {
  setIsLoading(true);
  const value = { value: { ...values } };
  await restRequest('put', 'old_accounts/update', value)
    .then((res) => {
      if (res) {
        handleToast(t('common.all_accounts_updated'), 'success');
        localStorage.setItem('skipBtnoldAccount', JSON.parse(false));
        window.location.href = '/dashboard';
      }
    })
    .catch((error) => {
      if (error) {
        setSubmitting(false);
        checkError(error);
        handleToast(error, 'error');
        setIsLoading(false);
        setTimeout(()=>window.location.reload(),1500);
      }
    });
};

const MapOldAccount = (props) => {
  const [data, setData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  let permissions = getObjFromLS('role').permissions;
  const {
    values,
    touched,
    errors,
    history,
    isLoading,
    handleSubmit,
    setIsLoading,
    setFieldValue,
    setFieldTouched,
    handleToast,
  } = props;

  useEffect(() => {
    document.title = 'Map Old Accounts';
    fetchAccounts();
  }, []);
  const fetchAccounts = () => {
    setIsLoading(true);
    restRequest('get', 'old_accounts').then((res) => {
      setData({ ...res.data });
      setIsLoading(false);
      handleToast(res.message, 'success');
      if (res.data?.total_old_accounts === 0) {
        setTimeout(() => window.location.reload(), 1500);
      }
    });
  };
  useEffect(() => {
    if (data?.accounts?.length > 0) {
      data.accounts.forEach((oldAcc) => {
        setFieldValue(oldAcc?.id, oldAcc.selected_id ? oldAcc.selected_id : '');
      });
    }
  }, [data, setFieldValue]);
  const onSkip = async () => {
    setIsLoading(true);
    await restRequest(
      'post',
      `skip-mapping/${localStorage.getItem('organization')}`
    ).then(()=>{localStorage.setItem('skipBtnoldAccount', JSON.parse(true));window.location.reload()}).catch((error) => {
      // console.log({error})
      setIsLoading(false);
      handleToast(error.response.data.message, 'error');
      // history.push('/dashboard');
      setTimeout(()=>window.location.reload(),1500)
      
    });
    
    // history.push('/dashboard');
  };

  const closeAllModals = () => {
    setIsModalOpen(false);
  };
  const onSave = (event) => {
    event.preventDefault();
    const formErrors = props.errors;
    if (Object.keys(formErrors).length > 0) {
      Object.keys(formErrors).forEach((key) => {
        setFieldTouched(key, true);
      });
      return;
    }
    setIsModalOpen(true);
  };

  const confirmSave = () => {
    handleSubmit();
    closeAllModals();
  };
  return (
    <div style={{ margin: 'auto', width: '600px', marginTop: '20px' }}>
      <>
        {!isLoading && data?.accounts?.length > 0 ? (
          <>
            {!permissions.superAccess && !data?.skip_mapping ? (
              <CoaUpdateCardWithMessage
                show={data}
                t={t}
                permissions={permissions}
                data={data}
              />
            ) : (
              <Form onSubmit={onSave}>
                <CoaUpdateCard show={data} t={t} />

                <h2 style={{ marginBottom: '20px', color: '#111827' }}>
                  {t('Settings.mapping_old_acounts')}
                </h2>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: '#f3f4f6',
                    padding: '10px 15px',
                    borderRadius: '6px',
                    fontWeight: '600',
                    fontSize: '14px',
                    marginBottom: '15px',
                    color: '#374151',
                  }}
                >
                  <span style={{ flex: 1, textAlign: 'left' }}>
                    Old Account
                  </span>
                  <span style={{ flex: 0.2, textAlign: 'center' }}>⇄</span>
                  <span style={{ flex: 2, textAlign: 'left' }}>
                    New Account
                  </span>
                </div>

                {data?.accounts?.map((oldAcc, i) => (
                  <div
                    key={i}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginBottom: '15px',
                      padding: '10px 15px',
                      borderBottom: '1px solid #e5e7eb',
                    }}
                  >
                    <label
                      htmlFor={oldAcc?.id}
                      style={{
                        flex: 1,
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#111827',
                      }}
                    >
                      {oldAcc?.label || oldAcc?.title}{' '}
                      <span className="red"> *</span>
                    </label>

                    <span
                      style={{
                        flex: 0.2,
                        textAlign: 'center',
                        fontSize: '16px',
                        color: '#6b7280',
                      }}
                    >
                      ⇄
                    </span>

                    <div style={{ flex: 2 }}>
                      <Field
                        required
                        size="large"
                        type="dropdown"
                        id={oldAcc?.id}
                        clearable={false}
                        dropdownValue="id"
                        dropdownLabel="title"
                        // name={oldAcc?.title}
                        value={values[oldAcc?.id]}
                        className="reg_timezone_field"
                        options={data?.account_options || []}
                        placeholder={`Select ${oldAcc.label}`}
                        handleChange={(option) => {
                          setFieldValue(
                            oldAcc?.id,
                            option ? option.value : null
                          );
                        }}
                        error={
                          touched[oldAcc?.id] &&
                          errors[oldAcc?.id] && (
                            <div style={{ color: 'red', marginTop: '5px' }}>
                              {errors[oldAcc?.title]}
                            </div>
                          )
                        }
                      />
                    </div>
                  </div>
                ))}

                <FormAction
                  disabled={false}
                  onCancel={onSkip}
                  cancelLabel="Skip for Now"
                  showCancel={data.show_skip_button}
                  className="clearfix"
                />
              </Form>
            )}
          </>
        ) : (
          <Loader />
        )}

        <CustomModal
          showModal={isModalOpen}
          renderActions={false}
          onClose={closeAllModals}
        >
          <p>{t('Settings.are_you_sure_you_want_to_save_the_changes')} </p>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
            }}
          >
            <button
              type="button"
              className="action-buttons--cancel cancel-btn"
              onClick={closeAllModals}
              style={{ marginRight: '10px' }}
            >
              {t('common.cancel')}
            </button>
            <button
              type="button"
              className="action-buttons--submit next-btn"
              onClick={confirmSave}
            >
              {t('PurchaseOrder.confirm')}
            </button>
          </div>
        </CustomModal>
      </>
    </div>
  );
};
const formEnhancer = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    const initialValues = {};
    if (props.accounts && props.accounts.length > 0) {
      props.accounts.forEach((account) => {
        initialValues[account.id] = account.selected_id || '';
      });
    }
    return initialValues;
  },
  validate: (values) => {
    const errors = {};
    Object.keys(values).forEach((key) => {
      if (!values[key]) {
        errors[key] = `${t('common.select_an_option_for')} ${key}`;
      }
    });
    return errors;
  },
  handleSubmit: (values, bag) => {
    const filteredData = Object.keys(values)
      .filter(
        (key) => typeof values[key] !== 'object' && values[key] !== undefined
      )
      .reduce((obj, key) => {
        obj[key] = values[key];
        return obj;
      }, {});
    handleFormSubmit(filteredData, bag);
  },
})(MapOldAccount);
export default formEnhancer;
function CoaUpdateCard({ show, t }) {
  const cardStyle = {
    maxWidth: '600px',
    margin: '40px auto',
    border: '1px solid #22c55e',
    borderRadius: '10px',
    backgroundColor: '#fff',
    padding: '20px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
  };

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    color: '#16a34a',
    fontWeight: 'bold',
    fontSize: '18px',
  };

  const textStyle = {
    color: '#374151',
    fontSize: '14px',
    marginBottom: '12px',
    lineHeight: '1.5',
  };

  const reminderBoxStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    backgroundColor: '#fef9c3',
    border: '1px solid #fde68a',
    borderRadius: '6px',
    padding: '10px',
    //marginBottom: '20px',
    fontSize: '13px',
    color: '#374151',
  };
  const date = new Date(show.skip_date || getOrganizationDate());

  return (
    <div style={cardStyle}>
      <div style={headerStyle}>
        <FaBullhorn style={{ marginRight: '8px' }} />
        {t('mapAccount.title')}
      </div>
      <p style={textStyle}>
        {t('mapAccount.intro1')}
        <span style={{ fontWeight: '600' }}> {t('mapAccount.coa')}</span>.
      </p>
      <p style={textStyle}>{t('mapAccount.intro2')}</p>
      {show?.show_skip_button && (
        <p style={textStyle}>{t('mapAccount.skipInfo')}</p>
      )}
      {show?.show_skip_button && (
        <div style={reminderBoxStyle}>
          <FaExclamationTriangle
            style={{ color: '#eab308', marginRight: '8px', marginTop: '2px' }}
          />
          <p>
            <span style={{ fontWeight: '600', marginRight: '3px' }}>
              {t('mapAccount.reminder')}
            </span>
            {t('mapAccount.reminder1')}{' '}
            <span style={{ fontWeight: '500' }}>
              {date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </span>
            {t('mapAccount.reminder2')}
          </p>
        </div>
      )}
    </div>
  );
}

function CoaUpdateCardWithMessage({ show, t, permissions, data }) {
  const cardStyle = {
    maxWidth: '600px',
    margin: '40px auto',
    border: '1px solid #22c55e',
    borderRadius: '10px',
    backgroundColor: '#fff',
    padding: '20px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
  };

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    color: '#16a34a',
    fontWeight: 'bold',
    fontSize: '18px',
  };

  const textStyle = {
    color: '#374151',
    fontSize: '14px',
    marginBottom: '12px',
    lineHeight: '1.5',
  };

  const reminderBoxStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    backgroundColor: '#fef9c3',
    border: '1px solid #fde68a',
    borderRadius: '6px',
    padding: '10px',
    fontSize: '13px',
    color: '#374151',
  };
  const date = new Date(show.skip_date || getOrganizationDate());

  return (
    <div style={cardStyle}>
      <div style={headerStyle}>
        <FaBullhorn style={{ marginRight: '8px' }} />
        {t('mapAccount.title')}
      </div>

      {/* Message line is included here */}
      <p style={textStyle}>{t('mapAccount.intro3')}</p>

      {show?.show_skip_button && (
        <>
          <div style={reminderBoxStyle}>
            <FaExclamationTriangle
              style={{ color: '#eab308', marginRight: '8px', marginTop: '2px' }}
            />
            <p>
              <span style={{ fontWeight: '600', marginRight: '3px' }}>
                {t('mapAccount.important')}
              </span>
              {t('mapAccount.reminder1')}{' '}
              <span style={{ fontWeight: '500' }}>
                {date.toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </span>
              {'.'}
              <br />
              {t('mapAccount.reminder3')}
            </p>
          </div>
        </>
      )}
    </div>
  );
}
